export const CHANGE_SCREEN = 'CHANGE_SCREEN'

export const CHANGE_USERINFO = 'CHANGE_USERINFO'

export const CHANGE_POWERBUTTON_LIST = 'CHANGE_POWERBUTTON_LIST'

export const CHANGE_SPECIAL_SCREEN = 'CHANGE_SPECIAL_SCREEN'

export const CHANGE_REGIONID = 'CHANGE_REGIONID'
